import { createContext, useContext, useReducer } from "react";

export const SpecialStore = createContext<IContextProps>(null);

interface IContextProps {
    state: IState;
    dispatch: ({ type }: Dispatch) => void;
}

type Dispatch = { type, payload }

class Search {
    activityName: string;
    useMemberClassID: string;
    activityStartDate: string;
    activityEndDate: string;
    discountType: string;
    purposeType: string;
    shopID: string;
    goodsID: string;
    disState: string;
    
    shopName: string;
    goodsName: string;
    orderBy: string;
    sort: string;
};

interface IState {
    searchList: any[];
    search: Search;
}

const initialArgs: IState = {
    searchList: [],
    search: new Search()
}

function reducer(state: IState, { type, payload }: Dispatch) {
    switch (type) {
        case "SetSearch":
            return {
                ...state,
                search: {
                    ...state.search,
                    ...payload
                }
            }
        case "SetSearchList":
            return {
                ...state,
                searchList: payload
            }
        default:
            return state;
    }
}

export function SpecialStoreProvider(props) {
    const [state, dispatch] = useReducer(reducer, initialArgs);

    const v = { state, dispatch };
    return <SpecialStore.Provider value={v}>{props.children}</SpecialStore.Provider>
}